import { createStore } from 'vuex'

export default createStore({
  state: {
    account: {
      int: 0
    },
    level: {
      int: 0
    },
    uid: {
      String: ''
    },
    myInfo: {}
  },
  getters: {
  },
  mutations: {
    setAccount(state, payload) {
      state.account.id = payload
    },
    setLevel(state, mlevel) {
      state.level = mlevel;
    },
    setUid(state, uid) {
      state.uid.id = uid
    },
    setMyInfo(state, myData) {
      state.myInfo = myData
    }
  },
  actions: {
  },
  modules: {
  }
})
